import React from "react";

interface EmailLogStatusPillProps {
  status?: string | null;
}

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  QUEUED: { bg: "bg-[#F1F3F5]", text: "#686E92" },
  SENT: { bg: "bg-[#C7DBFF]", text: "#1D4ED8" },
  DELIVERED: { bg: "bg-[#E2F6E8]", text: "#66AD7B" },
  OPENED: { bg: "bg-[#BDEFEA]", text: "#0F766E" },
  CLICKED: { bg: "bg-[#E2D4FF]", text: "#7C3AED" },
  BOUNCED: { bg: "bg-[#FFE8E8]", text: "#D61C1C" },
  DROPPED: { bg: "bg-[#FFE8E8]", text: "#D61C1C" },
  DEFERRED: { bg: "bg-[#FFF0E4]", text: "#FE961C" },
  SPAM_REPORT: { bg: "bg-[#FFE8E8]", text: "#D61C1C" },
  FAILED: { bg: "bg-[#FFE8E8]", text: "#D61C1C" },
};

const EVENT_STATUS_ALIASES: Record<string, string> = {
  PROCESSED: "SENT",
  DELIVERED: "DELIVERED",
  OPEN: "OPENED",
  OPENED: "OPENED",
  CLICK: "CLICKED",
  CLICKED: "CLICKED",
  BOUNCE: "BOUNCED",
  BOUNCED: "BOUNCED",
  DROPPED: "DROPPED",
  DEFERRED: "DEFERRED",
  SPAMREPORT: "SPAM_REPORT",
  SPAM_REPORT: "SPAM_REPORT",
  FAILED: "FAILED",
  QUEUED: "QUEUED",
  SENT: "SENT",
};

export const getEmailLogStatusColors = (status?: string | null) => {
  if (!status) return { bg: "bg-[#F1F3F5]", text: "#686E92" };
  const key = status.toUpperCase().replace(/[\s-]/g, "_");
  const mapped = EVENT_STATUS_ALIASES[key] || key;
  return (
    STATUS_COLORS[mapped] || {
      bg: "bg-[#F1F3F5]",
      text: "#686E92",
    }
  );
};

const EmailLogStatusPill: React.FC<EmailLogStatusPillProps> = ({ status }) => {
  const colors = getEmailLogStatusColors(status);
  return (
    <span
      className={`inline-flex h-[20px] items-center justify-center gap-1 whitespace-nowrap rounded px-[6px] text-[10px] font-medium uppercase ${colors.bg}`}
      style={{ color: colors.text }}
    >
      {status || "UNKNOWN"}
    </span>
  );
};

export const EmailLogStatusPillRenderer = (props: any) => {
  const status = props?.data?.status || props?.value || props?.status;
  return (
    <div className="flex h-full items-center">
      <EmailLogStatusPill status={status} />
    </div>
  );
};

export default EmailLogStatusPill;
